import { CoreButton, CoreCard, CoreFileCard, CoreFileInput } from "@verity/components/core";
import styles from "./InstructionStep.module.css";
import { Typography } from "@mui/material";
import i18n from "../../../../i18n";
import { baseTransKey, getFileTooBigErrorMessage, MAX_FILE_UPLOAD } from "./verityAssessmentHelper";
import InstructionEditor from "../../../../quill-editor/InstructionEditor";
import { useRef } from "react";
import { useScrollIntoView } from "@verity/components";
import PaperClipIcon from "../../../../images/portal/paper-clip.svg?react";
import { AddInstructionsReturn } from "./hooks/useAddInstructions";

const baseKey = `${baseTransKey}.addInstructions`;

export default function InstructionStep({
	instructionDelta,
	onInstructionsChange,
	onAddFile,
	onRemoveFile,
	uploadedFiles,
}: AddInstructionsReturn) {
	const fileInputRef = useRef<HTMLInputElement>(null);
	const { ref, scrollIntoView } = useScrollIntoView<HTMLDivElement>();

	return (
		<CoreCard slotProps={{ bodyWrapper: { className: styles.instructionCard } }}>
			<div className={styles.instructionHeader}>
				<Typography className={styles.instructionDescription}>{i18n.t(`${baseKey}.description`)}</Typography>
				<CoreButton
					className={styles.addMediaButton}
					onClick={() => fileInputRef.current?.click()}
					disabled={uploadedFiles.length >= MAX_FILE_UPLOAD}
					disabledTooltip={i18n.t(`${baseKey}.addMediaTooltip`, { number: MAX_FILE_UPLOAD }) as string}
					startIcon={<PaperClipIcon />}
					aria-haspopup="dialog"
				>
					<CoreFileInput
						ref={fileInputRef}
						accept={".jpg,.jpeg,.png,application/pdf,application/zip,application/x-zip-compressed"}
						onChange={(files) => {
							onAddFile(files);
							scrollIntoView();
						}}
					/>
					{i18n.t(`${baseKey}.addMedia`)}
				</CoreButton>
			</div>
			<InstructionEditor
				deltaStaticDefaultValue={instructionDelta}
				onChange={(value, _, __, editor) => {
					onInstructionsChange(value, editor.getContents());
				}}
			/>
			<div className={`${styles.uploadedFilesContainer} ${uploadedFiles.length === 0 ? styles.hidden : ""}`}>
				<Typography className={styles.uploadedFilesTitle}>{i18n.t(`${baseKey}.uploadedFile`)}</Typography>
				<div className={styles.uploadedFilesList} ref={ref}>
					{uploadedFiles.map((file, i) => {
						const errorMessage = getFileTooBigErrorMessage(file);
						return (
							<CoreFileCard
								key={i}
								file={file}
								onRemove={() => onRemoveFile(file.name)}
								showOpenInNewTab
								errorMessage={errorMessage}
							/>
						);
					})}
				</div>
			</div>
		</CoreCard>
	);
}
